<template>
  <v-form>
    <v-row>
      <v-col cols="12" md="10">
        <v-row>
          <v-col cols="12" md="4">
            <AutocompleteBus label="Tuyến xe" outlined dense clearable hide-details="auto" @change="busChange" />
          </v-col>
          <v-col cols="12" md="4">
            <v-select
              v-model="direction"
              :items="directionOptions"
              clear-icon="mdi-close"
              item-text="name"
              item-value="value"
              label="Chiều đi"
              outlined
              dense
              clearable
              :loading="loading"
              return-object
              :disabled="!directionOptions.length"
              hide-details
            />
          </v-col>
        </v-row>
      </v-col>
      <v-col class="d-flex align-end" cols="12" md="2">
        <v-btn outlined :disabled="!this.selectedBus || !direction" class="search-button" @click="onFilterChanged">
          Tìm kiếm
        </v-btn>
        <v-spacer />
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { mapState } from 'vuex'
import AutocompleteBus from '../../components/basic/input/AutocompleteBus.vue'
import { get } from 'lodash'
import { Bus } from '../../plugins/api'

export default {
  components: { AutocompleteBus },
  data: () => ({
    selectedBus: null,
    direction: null,
    loading: false,
    directionOptions: [],
    originalDirectionOptions: [
      { name: 'Đón sáng', value: '1', direction: 'in', periodTime: 'AM' },
      { name: 'Trả sáng', value: '2', direction: 'out', periodTime: 'AM' },
      { name: 'Đón chiều', value: '3', direction: 'in', periodTime: 'PM' },
      { name: 'Trả chiều', value: '4', direction: 'out', periodTime: 'PM' }
    ]
  }),
  computed: {
    ...mapState('constant', ['busStatus'])
  },
  methods: {
    onFilterChanged() {
      this.$emit('onFilterChanged', {
        bus: get(this.selectedBus, 'id', ''),
        periodTime: this.direction.periodTime,
        direction: this.direction.direction
      })
    },
    async busChange(bus) {
      this.selectedBus = bus

      if (get(this.selectedBus, 'id')) {
        this.loading = true
        const checkInfo = await Bus.getTotalInfoInBusToday(get(this.selectedBus, 'id'))
        const filteredInfo = checkInfo.filter(info => info.studentsRegister > 0)

        const filteredOptions = this.originalDirectionOptions.filter(option => {
          const matchingInfo = filteredInfo.find(
            info => info.direction === option.direction && info.periodTime === option.periodTime
          )

          return matchingInfo
        })
        this.loading = false
        this.directionOptions = filteredOptions
      } else {
        this.directionOptions = []
      }
    }
  }
}
</script>

<style scoped></style>
